export const dummyusers = [
  {
    _id: 1,
    name: 'Gunnar Verhulst',
    email: 'verhulstg@hotmail.com',
    password: 'password',
    address1: 'Handelsstraat 59',
    address2: '2400 Mol Belgium',
    phone: '+32497713122',
    isAdmin: true,
  },
  {
    _id: 2,
    name: 'Gitte Versweyveld',
    email: 'versweyveldgitte@hotmail.com',
    password: 'password',
    address1: 'Handelsstraat 59',
    address2: '2400 Mol Belgium',
    phone: '+32479835235',
    isAdmin: false,
  },
];

export const dummylessons = [
  {
    _id: 1,
    date: new Date('2023-05-07T10:00:00.000'),
    duration: '45 min',
    age: 'Kleuters 2,5 - 6 jaar',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    type: 'Family Acro Yoga',
    upcoming: false,
    showLesson: true,
  },
  {
    _id: 2,
    date: new Date('2023-05-07T11:30:00.000'),
    duration: '45 min',
    age: '7+ jaar',
    location: {
      name: 'Zaaltje vzw LouTieJu',
      address: 'Ongelberg 146 2490 Balen',
    },
    type: 'Family Acro Yoga',
    upcoming: false,
    showLesson: true,
  },
];
